import { createSelector } from 'reselect'
import getDynamicPaymentSchedule from './getDynamicPaymentSchedule'

const getDynamicPaymentSchedulePaymentServiceFee = createSelector(
  getDynamicPaymentSchedule,
  (dynamicPaymentSchedule): number => {
    if (!dynamicPaymentSchedule?.eligible || !dynamicPaymentSchedule?.initialPaymentSchedule) {
      return 0
    }
    return dynamicPaymentSchedule.initialPaymentSchedule.feeAmount || 0
  },
)

export default getDynamicPaymentSchedulePaymentServiceFee
